export default "assets/images/icons/collapse-56b31967.svg";